import React, { useState } from "react";

type PermissionType =
  | "create"
  | "edit"
  | "view"
  | "assign"
  | "delete"
  | "allowAll";
interface PermissionItem {
  id: number;
  name: string;
  haveaccess: boolean;
}
interface Permission {
  screenName: string;
  create: boolean;
  edit: boolean;
  view: boolean;
  assign: boolean;
  delete: boolean;
  allowAll: boolean;
  moduleId: number;
  fk_SubModuleId: number;
  permissionList: PermissionItem[];
}

interface PermissionsComponentProps {
  permissions: Permission[];
  onTableHeadChange: (
    moduleId: any,
    type: PermissionType,
    isChecked: boolean
  ) => void;
  onRowChange: (index: number, isChecked: boolean) => void;
  onIndividualChange: (
    index: number,
    type: PermissionType | number,
    isChecked: boolean,
    isNested?: boolean
  ) => void;
  onMasterChange: (isChecked: boolean) => void;
  handleAllowAllChange: (moduleId: any, isChecked: boolean) => void;
  moduleId: number;
}

const PermissionsComponent: React.FC<PermissionsComponentProps> = ({
  permissions,
  onTableHeadChange,
  onRowChange,
  onIndividualChange,
  onMasterChange,
  handleAllowAllChange,
  moduleId,
}) => {
  const [expandedRow, setExpandedRow] = useState<number | null>(null);

  const handleRowClick = (index: number, permissionList: any) => {
    if (permissionList !== null && permissionList?.length > 0) {
      setExpandedRow((prev) => (prev === index ? null : index)); // Toggle open/close
    }
  };
  return (
    <div>
      <div className="table-responsive custom-table">
        <table className="table datanew dataTable no-footer table-hover">
          <thead>
            <tr>
              <th>Module Name</th>
              <th>
                <input
                  type="checkbox"
                  className="form-check-input cursor-pointer"
                  // checked={permissions.every(p => p.create)}
                  checked={permissions
                    .filter((p) => p.moduleId === moduleId)
                    .every((p) => p.create)}
                  onChange={(e) =>
                    onTableHeadChange(moduleId, "create", e.target.checked)
                  }
                />{" "}
                Create
              </th>
              <th>
                <input
                  type="checkbox"
                  className="form-check-input cursor-pointer"
                  checked={permissions
                    .filter((p) => p.moduleId === moduleId)
                    .every((p) => p.edit)}
                  onChange={(e) =>
                    onTableHeadChange(moduleId, "edit", e.target.checked)
                  }
                />{" "}
                Edit
              </th>
              <th>
                <input
                  type="checkbox"
                  className="form-check-input cursor-pointer"
                  checked={permissions
                    .filter((p) => p.moduleId === moduleId)
                    .every((p) => p.view)}
                  onChange={(e) =>
                    onTableHeadChange(moduleId, "view", e.target.checked)
                  }
                />{" "}
                View
              </th>
              <th>
                <input
                  type="checkbox"
                  className="form-check-input cursor-pointer"
                  checked={permissions
                    .filter((p) => p.moduleId === moduleId)
                    .every((p) => p.assign)}
                  onChange={(e) =>
                    onTableHeadChange(moduleId, "assign", e.target.checked)
                  }
                />{" "}
                Assign
              </th>
              <th>
                <input
                  type="checkbox"
                  className="form-check-input cursor-pointer"
                  checked={permissions
                    .filter((p) => p.moduleId === moduleId)
                    .every((p) => p.delete)}
                  onChange={(e) =>
                    onTableHeadChange(moduleId, "delete", e.target.checked)
                  }
                />{" "}
                Delete
              </th>
              <th>
                <input
                  type="checkbox"
                  className="form-check-input cursor-pointer"
                  checked={permissions
                    .filter((p) => p.moduleId === moduleId)
                    .every(
                      (p) =>
                        p.create && p.edit && p.view && p.assign && p.delete
                    )}
                  onChange={(e) =>
                    handleAllowAllChange(moduleId, e.target.checked)
                  }
                />{" "}
                Allow All
              </th>
            </tr>
          </thead>
          <tbody>
            {permissions
              ?.map((permission, index) => ({
                ...permission,
                originalIndex: index,
              })) // Store original index
              .filter((permission) => {
                return permission.moduleId === moduleId;
              })
              .map((permission) => {
                const originalIndex = permission.originalIndex;
                return (
                  <React.Fragment key={originalIndex}>
                    <tr className="cursor-pointer">
                      <td>
                        {permission?.screenName}
                        {permission?.permissionList !== null &&
                          permission?.permissionList?.length > 0 && (
                            <button
                              className="btn btn-primary ms-3 px-2 py-0"
                              onClick={() => {
                                setExpandedRow(
                                  expandedRow === originalIndex
                                    ? null
                                    : originalIndex
                                );
                              }}
                            >
                              {expandedRow === originalIndex ? "-" : "+"}
                            </button>
                          )}
                      </td>
                      <td>
                        <input
                          type="checkbox"
                          className="form-check-input cursor-pointer"
                          checked={permission.create}
                          onChange={(e) => {
                            onIndividualChange(
                              originalIndex,
                              "create",
                              e.target.checked
                            );
                          }}
                        />
                      </td>
                      <td>
                        <input
                          type="checkbox"
                          className="form-check-input cursor-pointer"
                          checked={permission.edit}
                          onChange={(e) => {
                            onIndividualChange(
                              originalIndex,
                              "edit",
                              e.target.checked
                            );
                          }}
                        />
                      </td>
                      <td>
                        <input
                          type="checkbox"
                          className="form-check-input cursor-pointer"
                          checked={permission.view}
                          onChange={(e) => {
                            onIndividualChange(
                              originalIndex,
                              "view",
                              e.target.checked
                            );
                          }}
                        />
                      </td>
                      <td>
                        <input
                          type="checkbox"
                          className="form-check-input cursor-pointer"
                          checked={permission.assign}
                          onChange={(e) => {
                            onIndividualChange(
                              originalIndex,
                              "assign",
                              e.target.checked
                            );
                          }}
                        />
                      </td>
                      <td>
                        <input
                          type="checkbox"
                          className="form-check-input cursor-pointer"
                          checked={permission.delete}
                          onChange={(e) => {
                            onIndividualChange(
                              originalIndex,
                              "delete",
                              e.target.checked
                            );
                          }}
                        />
                      </td>
                      <td>
                        <input
                          type="checkbox"
                          className="form-check-input cursor-pointer"
                          checked={
                            permission.delete &&
                            permission.assign &&
                            permission.edit &&
                            permission.view &&
                            permission.create
                          }
                          onChange={(e) => {
                            onRowChange(originalIndex, e?.target?.checked);
                          }}
                        />
                      </td>
                    </tr>

                    {/* Expanded Row */}
                    {expandedRow === originalIndex &&
                      permission?.permissionList !== null &&
                      permission?.permissionList?.length !== 0 && (
                        <tr key={`expanded-${originalIndex}`}>
                          <td colSpan={8}>
                            <div className="table-responsive">
                              <table className="table datanew dataTable no-footer table-hover">
                                <thead>
                                  <tr className="bg-gray-100">
                                    <th className="border border-gray-300 px-4 py-2 text-center">
                                      Name
                                    </th>
                                    <th className="border border-gray-300 px-4 py-2 text-center">
                                      Access
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {permission?.permissionList?.map(
                                    (
                                      item: {
                                        name: string;
                                        haveaccess: boolean;
                                      },
                                      index: number
                                    ) => {
                                      return (
                                        <tr key={index} className="text-center">
                                          <td className="border border-gray-300 px-4 py-2">
                                            {item.name}
                                          </td>
                                          <td className="border border-gray-300 px-4 py-2">
                                            <input
                                              type="checkbox"
                                              className="form-check-input cursor-pointer"
                                              checked={item.haveaccess}
                                              onChange={(e) => {
                                                onIndividualChange(
                                                  originalIndex,
                                                  index,
                                                  e.target.checked,
                                                  true
                                                );
                                              }}
                                            />
                                          </td>
                                        </tr>
                                      );
                                    }
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </td>
                        </tr>
                      )}
                  </React.Fragment>
                );
              })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PermissionsComponent;
